import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { useSite } from "../context/SiteContext";
import { GALLERY_PHOTOS } from "../lib/site";

export default function Gallery() {
  const { rooms, gallery } = useSite();
  const galleryPhotos = gallery.length ? gallery.map((p) => p.image) : GALLERY_PHOTOS;
  const shots = [
    ...galleryPhotos.map((image, i) => ({ image, caption: `Madhubhan Resort & Spa · ${String(i + 1).padStart(2, "0")}` })),
    ...rooms.filter((room) => room.image).map((room) => ({ image: room.image, caption: room.name })),
  ];
  return (
    <main>
      <PageHero
        image={GALLERY_PHOTOS[1]}
        eyebrow="Gallery"
        lines={[<>A look</>, <em>around.</em>]}
        lede="Rooms, gardens, water and light — a slow walk through Madhubhan before you arrive."
      />
      <section className="section-pad intro" data-testid="gallery-grid-section">
        <div className="gallery-grid">
          {shots.map((shot, i) => (
            <Reveal key={`${shot.caption}-${i}`} delay={(i % 3) * 0.07} className="gallery-item" data-testid={`gallery-item-${i}`}>
              <img src={shot.image} alt={shot.caption} loading="lazy" />
              <span>{shot.caption}</span>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
